import { getMemberVerify } from 'Api/AccountApi';
import { sanitizePath } from 'Utils/Path';
import { localStorageGet, localStorageRemove, localStorageSet } from 'Utils/Storage';
import { setState } from 'Utils/Store';

const MOCK_SHEER_ERROR = {
  errorType: 'Not Found',
  errorMessage: 'verification id not found',
};

export const integrationsInitialState = {
  bango: {
    subscriptionId: '',
    redirectUrl: '',
    productId: '',
  },
  sheerId: {
    verificationId: '',
    program: '', //military or firstResponder
    step: '',
  },
  veteransAdv: {
    member_id: '',
    error: null,
  },
};

export const setBango = (payload) => {
  setState('integrations', { bango: payload });
};

export const resetIntegrations = () => {
  setState('integrations', integrationsInitialState);
};

export const setInitialStep = (payload) => {
  setState('integrations.sheerId', { step: payload });
};

export const setRedirectUrl = (payload) => {
  setState('integrations.bango', { redirectUrl: payload });
};

export const setSheerProgram = (payload) => {
  setState('integrations.sheerId', { program: payload });
};

export const setSheerVerificationId = (payload) => {
  setState('integrations.sheerId', { verificationId: payload });
};

export const clearSheerId = () => {
  setState('integrations.sheerId', { sheerId: integrationsInitialState.sheerId });
};

export const setVeteransAdvId = (payload) => {
  setState('integrations.veteransAdv', { member_id: payload });
};

export const setVeteransAdvError = (payload) => {
  setState('integrations.veteransAdv', { error: payload });
};

export const clearVeteransAdvId = () => {
  setState('integrations.veteransAdv', { memberId: integrationsInitialState.veteransAdv.member_id });
};

export const clearVeteransAdvError = () => {
  setState('integrations.veteransAdv', { error: integrationsInitialState.veteransAdv.error });
};

//bango
export const checkBangoParams = () => {
  const windowUrl = window?.location?.search?.replace('\\u0026', '&');
  const query = new URLSearchParams(windowUrl);
  const subscriptionId = query.get('subscriptionRequestId') || localStorageGet('subscriptionRequestId') || '';
  const redirectUrl = query.get('redirect_uri') || localStorageGet('redirect_uri') || '';
  const productId = query.get('productId') || localStorageGet('productId') || '';

  if (subscriptionId) {
    localStorageSet('subscriptionRequestId', subscriptionId);
    localStorageSet('redirect_uri', redirectUrl);
    localStorageSet('productId', productId);
    return setBango({ subscriptionId, redirectUrl, productId });
  }
};

export const addRedirectUrl = (redirectUrl) => {
  const sanitizedUrl = sanitizePath(redirectUrl);
  if (sanitizedUrl !== false) {
    localStorageSet('redirect_uri', sanitizedUrl);
    return setRedirectUrl(sanitizedUrl);
  }
};

//sheerid
export const getUserSheerInfo = async () => {
  const response = await getMemberVerify();
  const { program, verificationId, verifier } = response;

  if (verifier !== 'sheerid') {
    throw new Error(MOCK_SHEER_ERROR);
  }

  setSheerVerificationId(verificationId);
  setSheerProgram(program);
  return response;
};

export const clearIntegrations = () => {
  localStorageRemove('subscriptionRequestId');
  localStorageRemove('redirect_uri');
  localStorageRemove('productId');
  resetIntegrations();
};
